import type { PermissionKey } from '../auth/permissions'

export interface ModuleDefinition {
  key: string
  label: string
  description: string
  icon: string
  order: number
  systemState: 'enabled' | 'unavailable'
  version: number
  critical: boolean
  managePermission: PermissionKey
  accessPermission: PermissionKey
  dependencies: { key: string; required: boolean }[]
}

/** Immutable product keys. Internal services (storage, standards) are not products. */
export const MODULE_CATALOG: readonly ModuleDefinition[] = [
  {
    key: 'quality',
    label: 'Qualité',
    description: 'Pilotez votre système de management et vos démarches qualité.',
    icon: 'shield',
    order: 10,
    systemState: 'enabled',
    version: 1,
    critical: true,
    managePermission: 'quality.module.manage',
    accessPermission: 'quality.access',
    dependencies: [],
  },
  {
    key: 'vendor-management',
    label: 'Fournisseurs',
    description: 'Structurez vos relations et le suivi de vos fournisseurs.',
    icon: 'building',
    order: 20,
    systemState: 'enabled',
    version: 1,
    critical: true,
    managePermission: 'vendor.module.manage',
    accessPermission: 'vendor.access',
    dependencies: [],
  },
  {
    key: 'questionnaires',
    label: 'Forms',
    description: 'Créez des formulaires dynamiques et recueillez les réponses utiles.',
    icon: 'clipboard',
    order: 30,
    systemState: 'enabled',
    version: 1,
    critical: false,
    managePermission: 'questionnaires.module.manage',
    accessPermission: 'questionnaires.access',
    dependencies: [],
  },
  {
    key: 'approvals',
    label: 'Validations',
    description: 'Workflows et décisions.',
    icon: 'check',
    order: 40,
    systemState: 'enabled',
    version: 1,
    critical: false,
    managePermission: 'approvals.workflows.manage',
    accessPermission: 'approvals.access',
    dependencies: [],
  },
  {
    key: 'inventory',
    label: 'Inventaire',
    description: 'Gestion des actifs et ressources.',
    icon: 'box',
    order: 50,
    systemState: 'enabled',
    version: 1,
    critical: false,
    managePermission: 'inventory.settings.manage',
    accessPermission: 'inventory.read',
    dependencies: [],
  },
  {
    key: 'quality.audits',
    label: 'Audits qualité',
    description: 'Préparation et réalisation des audits.',
    icon: 'clipboard',
    order: 60,
    systemState: 'enabled',
    version: 1,
    critical: false,
    managePermission: 'quality.audits.manage',
    accessPermission: 'quality.audits.read',
    dependencies: [{ key: 'quality', required: true }],
  },
]
export const LEGACY_MODULE_KEYS = ['quality', 'vendor-management', 'questionnaires'] as const
export function getModuleDefinition(key: string, catalog = MODULE_CATALOG) {
  return catalog.find((module) => module.key === key)
}

/** Business routes include Quality configuration; module licensing administration stays outside. */
export function moduleForPath(path: string, catalog = MODULE_CATALOG) {
  const normalized = path
    .replace(/^\/api(?=\/)/, '')
    .replace(/^\/admin\/(quality|approvals|inventory)(?=\/|$)/, '/$1')
    .replace(/^\/forms(?=\/|$)/, '/questionnaires')
  if (normalized === '/quality/audits' || normalized.startsWith('/quality/audits/'))
    return getModuleDefinition('quality.audits', catalog)
  return catalog.find(({ key }) => normalized === `/${key}` || normalized.startsWith(`/${key}/`))
}
